import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../components";
import { BasepayOpetions, Paymenttypeopetions, PayPeriodoptions, PayProfileoptions, perDiemPaymentTypeOptions } from "../../../../../../assets/data/projectData";

const AdjustPayCycleModal = ({ open, onClose }) => {
  const { formData, errors, handleChange } = useFormHandler({
    payProfile: "",
    placements: "",
    period: "",
    Salary: "",
    monthSalary: "",
    DiemPaymentType: "",
    BasePay2: "",
    payCycle: "",
    basePay: "",
    onlyBasePayIsPaid: "",
  });

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="PROFILE CHANGE"
      width="max-w-5xl"
    >
      <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
        <FormFieldSet
          type="select"
          title={"Pay Profile"}
          placeholder="Select Pay Profile"
          value={formData.payProfile}
          onChange={(value) => handleChange("payProfile", value)}
          error={errors.payProfile}
          options={PayProfileoptions}
        />
        <FormFieldSet
          type="select"
          title={"Payment Type"}
          placeholder="As Per placements"
          value={formData.placements}
          onChange={(value) => handleChange("placements", value)}
          error={errors.placements}
           options={Paymenttypeopetions}
        />
        <FormFieldSet
          type="select"
          title={"Pay period"}
          placeholder="Select Pay period"
          value={formData.period}
          onChange={(value) => handleChange("period", value)}
          error={errors.period}
            options={PayPeriodoptions}
        />
      </div>
      <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
        <div className="mt-5 ml-2">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "only Base Pay is Paid",
                value: true,
              },
            ]}
            values={formData.onlyBasePayIsPaid || []}
            onChange={(value) => handleChange("onlyBasePayIsPaid", value)}
            multiple
          />
        </div>
        <FormFieldSet
          type="text"
          title={"Enter Salary"}
          placeholder="Select Pay period"
          value={formData.Salary}
          onChange={(value) => handleChange("Salary", value)}
          error={errors.Salary}
        />
        <FormFieldSet
          type="text"
          title={"Salary"}
          placeholder="(/month)"
          value={formData.monthSalary}
          onChange={(value) => handleChange("monthSalary", value)}
          error={errors.monthSalary}
        />
      </div>
      <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl mt-4">
        <div className="col-span-1 flex gap-1 ">
          <FormFieldSet
            type="text"
            title={"Enter Base Pay"}
            placeholder="Enter"
            value={formData.basePay}
            onChange={(value) => handleChange("basePay", value)}
            error={errors.basePay}
          />
          <div>
            <FormFieldSet
              type="select"
              title={" "}
              placeholder="Pay Cycle"
              value={formData.payCycle}
              onChange={(value) => handleChange("payCycle", value)}
              error={errors.payCycle}
               options={BasepayOpetions}
            />
          </div>
        </div>
        <FormFieldSet
          type="text"
          title={"Base Pay"}
          placeholder="Enter"
          value={formData.BasePay2}
          onChange={(value) => handleChange("BasePay2", value)}
          error={errors.BasePay2}
        />
        <FormFieldSet
          type="select"
          title={"Per Diem Payment Type"}
          placeholder="Not Applicable"
          value={formData.DiemPaymentType}
          onChange={(value) => handleChange("DiemPaymentType", value)}
          error={errors.DiemPaymentType}
           options={perDiemPaymentTypeOptions}
        />
      </div>
      <div className="flex justify-end  gap-x-2 mt-8 ">
        <Button title="Cancel" variant="outlined" onClick={onClose} />
        <Button
          title="Save"
          variant="contained"
          color="primary"
          onClick={onClose}
        />
      </div>
    </Modal>
  );
};

export default AdjustPayCycleModal;